import { AddIcon, ChevronDownIcon, ChevronLeftIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Divider,
  Fade,
  Flex,
  FormLabel,
  HStack,
  Input,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Spinner,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useBreakpointValue,
  useDisclosure,
  useToast
} from '@chakra-ui/react';
import exportFromJSON from 'export-from-json';
import { useEffect, useState } from 'react';
import { HiPlusCircle } from 'react-icons/hi';
import { Column } from 'react-table';
import MaskedInput from 'react-text-mask';

import { InteractiveTable } from '../../../components/data/InteractiveTable';
import { ValueCard } from '../../../components/data/ValueCard';
import { api } from '../../../services/api';
import { apiSensedia } from '../../../services/api-sensedia';
import { cpf } from '../../../utils/masks';

type Table = {
  NOME_CLIENTE: string;
  CPF_CLIENTE: string;
  PROPOSTA: number;
  FUNDO: string;
  DATA_SOLICITACAO: string;
  DATA_PAGAMENTO: string;
  STATUS: string;
};

type Data = {
  summarized: {
    quantidade: string;
    liquido: string;
    solicitado: string;
    // ev: string;
    // fundos: [
    //   {
    //     nome_fundo: string;
    //     saldo: string;
    //     participantes: [
    //       {
    //         nome: string;
    //         cpf: string;
    //         proposta: string;
    //         saldo: string;
    //       }
    //     ];
    //   }
    // ];
  };
  table: Table[];
};

type HandleDetails = {
  row: {
    original: {
      CPF_CLIENTE: string;
      PROPOSTA: string;
      DATA_SOLICITACAO: string;
    };
  };
};

type Details = {
  SEGURADO: string;
  NUMERO_PROPOSTA: number;
  NOME_FUNDO: string;
};

export const ConsultaResgates = (): JSX.Element => {
  const toast = useToast();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenDetails,
    onOpen: onOpenDetails,
    onClose: onCloseDetails
  } = useDisclosure();

  const [loading, setLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [loadingDetails, setLoadingDetails] = useState(false);

  const [data, setData] = useState<Data>({
    summarized: {
      quantidade: '0',
      liquido: '0',
      solicitado: '0'
    },
    table: [
      {
        NOME_CLIENTE: '',
        CPF_CLIENTE: '',
        PROPOSTA: 0,
        FUNDO: '',
        DATA_SOLICITACAO: '',
        DATA_PAGAMENTO: '',
        STATUS: ''
      }
    ]
  });

  const [table, setTable] = useState<Table[]>([
    {
      NOME_CLIENTE: '',
      CPF_CLIENTE: '',
      PROPOSTA: 0,
      FUNDO: '',
      DATA_SOLICITACAO: '',
      DATA_PAGAMENTO: '',
      STATUS: ''
    }
  ]);

  const [details, setDetails] = useState<Details[]>([
    {
      SEGURADO: '',
      NUMERO_PROPOSTA: 0,
      NOME_FUNDO: ''
    }
  ]);

  const [itemsCount, setItemsCount] = useState(0);
  const [itemsToShow, setItemsToShow] = useState(5);

  const [count, setCount] = useState('0');
  const [liquido, setLiquido] = useState('0');
  const [solicitado, setSolicitado] = useState('0');

  const [initialDate, setInitialDate] = useState('');
  const [finalDate, setFinalDate] = useState('');
  const [cpfFilter, setCpfFilter] = useState('');
  const [nameFilter, setNameFilter] = useState('');

  const columns: Column<object>[] = [
    {
      Header: '',
      accessor: 'DETAILS',
      Cell: ({ row }: HandleDetails) => (
        <>
          <Tooltip label="Detalhes">
            <Button
              as={AddIcon}
              cursor="pointer"
              variant="ghost"
              w="2.8rem"
              onClick={() =>
                handleDetails(
                  row.original.CPF_CLIENTE,
                  row.original.PROPOSTA,
                  row.original.DATA_SOLICITACAO
                )
              }
            />
          </Tooltip>
        </>
      )
    },
    {
      Header: 'Participante',
      accessor: 'NOME_CLIENTE'
    },
    {
      Header: 'CPF',
      accessor: 'CPF_CLIENTE'
    },
    {
      Header: 'Proposta',
      accessor: 'PROPOSTA'
    },
    // {
    //   Header: 'Nome do fundo',
    //   accessor: 'FUNDO'
    // },
    {
      Header: 'Data da Solicitação',
      accessor: 'DATA_SOLICITACAO'
    },
    {
      Header: 'Data de pagamento',
      accessor: 'DATA_PAGAMENTO'
    },
    {
      Header: 'Status',
      accessor: 'STATUS'
    }
  ];

  const handleFilter = async () => {
    setLoadingTable(true);

    if (
      (initialDate && !finalDate) ||
      (!initialDate && finalDate) ||
      finalDate < initialDate
    ) {
      toast({
        position: 'top',
        description: 'Favor verificar o preenchimento das datas',
        status: 'warning',
        duration: 7000,
        isClosable: true
      });

      setLoadingTable(false);

      return;
    }

    if (cpfFilter.length > 0 && cpfFilter.length < 14) {
      toast({
        position: 'top',
        description: 'CPF incompleto, favor verificar o preenchimento',
        status: 'warning',
        duration: 9000,
        isClosable: true
      });

      setLoadingTable(false);

      return;
    }

    await getData();

    setLoadingTable(false);
  };

  const handleClearFilters = async () => {
    setLoading(true);

    setInitialDate('');
    setFinalDate('');
    setCpfFilter('');
    setNameFilter('');

    try {
      const token = localStorage.getItem('tokenPortal');

      const response = await apiSensedia.get(
        `/gestao-de-carteiras/movimentacoes-resgates`,
        {
          timeout: 0
        }
      );

      if (response.data.data.table) {
        setData({
          summarized: {
            quantidade: response.data.data.summarize.count,
            liquido: response.data.data.summarize.net.toLocaleString('pt-BR'),
            solicitado:
              response.data.data.summarize.gross.toLocaleString('pt-BR')
          },
          table: response.data.data.table
        });

        const howManyDistinct = await checkLGPD(response.data.data.table);

        setTable(response.data.data.table);
        setCount(response.data.data.summarize.count);
        setLiquido(
          howManyDistinct > 2
            ? response.data.data.summarize.net.toLocaleString('pt-BR')
            : '-'
        );
        setSolicitado(
          howManyDistinct > 2
            ? response.data.data.summarize.gross.toLocaleString('pt-BR')
            : '-'
        );
        setItemsCount(
          response.data.data.table.length > 10
            ? 10
            : response.data.data.table.length
        );
      }
    } catch (e: any) {
      if (e.response.status === 401) {
        onOpen();
      } else {
        const errorObj = e?.toJSON();
        const hasStatus = errorObj?.status || e?.response?.data?.statusCode;
        const hasMessage = errorObj?.message || e?.response?.data?.message;
        toast({
          position: 'top',
          description: (
            <Box>
              <Text>
                {' '}
                Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
                minutos e tente fazer login novamente, se persistir, por favor
                entrar em contato.
              </Text>
              <Text>
                {hasStatus && (
                  <>
                    <br />
                    <b>Detalhes:</b>
                    <br />
                  </>
                )}
                {hasStatus && (
                  <>{errorObj.status ?? e.response.data.statusCode}</>
                )}
                {hasStatus && hasMessage && ' - '}
                {hasMessage && (
                  <>{e.response.data.message ?? errorObj.message}</>
                )}
              </Text>
            </Box>
          ),
          duration: 15000,
          isClosable: true,
          status: 'error'
        });
      }

      setLoading(false);
    }

    setLoading(false);
  };

  const checkLGPD = async (table: Table[]) => {
    const count = table
      .map((item) => `${item.CPF_CLIENTE} + ${item.PROPOSTA}`)
      .filter((value, index, self) => self.indexOf(value) === index);

    return count.length;
  };

  const handleDetails = async (
    cpf: string,
    proposta: string,
    dataSolicitacao: string
  ) => {
    try {
      setLoadingDetails(true);

      onOpenDetails();

      const dataSolicitacaoFormated = dataSolicitacao
        .split('/')
        .reverse()
        .join('/')
        .replaceAll('/', '-');

      const response = await apiSensedia.get(
        `/gestao-de-carteiras/movimentacoes-resgates?&=${proposta}`,
        {
          headers: { cpf },
          params: {
            dataSolicitacao: dataSolicitacaoFormated,
            proposta
          },
          timeout: 0
        }
      );
      if (response.data.data) {
        setLoadingDetails(false);
        if (
          response.data.data.details &&
          response.data.data.details.length === 0
        ) {
          onCloseDetails();
          return toast({
            position: 'top',
            description: 'Não foram encontrados registros.',
            status: 'warning',
            duration: 4000,
            isClosable: true
          });
        }
        setDetails(response.data.data.details);
      }
    } catch (error: any) {
      if (error.response.status === 401) {
        onCloseDetails();
        onOpen();
      } else {
        const errorObj = error?.toJSON();
        toast({
          position: 'top',
          description: (
            <Box>
              <Text>
                {' '}
                Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
                minutos e tente fazer login novamente, se persistir, por favor
                entrar em contato.
              </Text>
              <Text>
                {errorObj?.status && (
                  <>
                    <br />
                    <b>Detalhes:</b>
                    <br />
                  </>
                )}
                {(errorObj?.status || error?.response?.data?.statusCode) && (
                  <>{errorObj.status ?? error.response.data.statusCode}</>
                )}
                {errorObj?.status &&
                  (error?.response?.data?.message || errorObj?.message) &&
                  ' - '}
                {(error?.response?.data?.message || errorObj?.message) && (
                  <>{error.response.data.message ?? errorObj.message}</>
                )}
              </Text>
            </Box>
          ),
          duration: 15000,
          isClosable: true,
          status: 'error'
        });
      }

      setLoading(false);
    }
  };

  const getData = async () => {
    setLoading(true);

    try {
      const response = await apiSensedia.get(
        `/gestao-de-carteiras/movimentacoes-resgates?dataInicio=${initialDate}&dataFim=${finalDate}&nome=${nameFilter}&cpf=${cpfFilter
          .replaceAll('.', '')
          .replace('-', '')}`,
        {
          timeout: 0
        }
      );

      if (response.data.data.table) {
        setData({
          summarized: {
            quantidade: response.data.data.summarize.count,
            liquido: response.data.data.summarize.net.toLocaleString('pt-BR'),
            solicitado:
              response.data.data.summarize.gross.toLocaleString('pt-BR')
          },
          table: response.data.data.table
        });

        const howManyDistinct = await checkLGPD(response.data.data.table);

        setTable(response.data.data.table);
        setCount(response.data.data.summarize.count);
        setLiquido(
          howManyDistinct > 2
            ? response.data.data.summarize.net.toLocaleString('pt-BR')
            : '-'
        );
        setSolicitado(
          howManyDistinct > 2
            ? response.data.data.summarize.gross.toLocaleString('pt-BR')
            : '-'
        );
        setItemsCount(
          response.data.data.table.length > 10
            ? 10
            : response.data.data.table.length
        );
      }
    } catch (e: any) {
      if (e.response.status === 401) {
        onOpen();
      } else {
        const errorObj = e?.toJSON();
        const hasStatus = errorObj?.status || e?.response?.data?.statusCode;
        const hasMessage = errorObj?.message || e?.response?.data?.message;
        toast({
          position: 'top',
          description: (
            <Box>
              <Text>
                {' '}
                Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
                minutos e tente fazer login novamente, se persistir, por favor
                entrar em contato.
              </Text>
              <Text>
                {hasStatus && (
                  <>
                    <br />
                    <b>Detalhes:</b>
                    <br />
                  </>
                )}
                {hasStatus && (
                  <>{errorObj.status ?? e.response.data.statusCode}</>
                )}
                {hasStatus && hasMessage && ' - '}
                {hasMessage && (
                  <>{e.response.data.message ?? errorObj.message}</>
                )}
              </Text>
            </Box>
          ),
          duration: 15000,
          isClosable: true,
          status: 'error'
        });
      }

      setLoading(false);
    }

    setLoading(false);
  };

  const exportData = (ext: 'csv' | 'xls') => {
    const data = formatDataEfetivado();
    const fileName = `Dados`;
    const exportType = exportFromJSON.types[ext];

    exportFromJSON({ data, fileName, exportType });
  };

  const formatDataEfetivado = () => {
    return data.table.map((item) => {
      return {
        participante: item.NOME_CLIENTE,
        cpfCliente: item.CPF_CLIENTE,
        proposta: item.PROPOSTA,
        dataSolicitacao: item.DATA_SOLICITACAO,
        dataPagamento: item.DATA_PAGAMENTO,
        status: item.STATUS
      };
    });
  };

  useEffect(() => {
    getData();
  }, []);

  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true
  });

  return (
    <Stack p="1.7vw 11.5vw" spacing={23}>
      <Stack spacing={7}>
        <Stack spacing={1}>
          <Link href="/corretor" w="4rem">
            <HStack spacing={0}>
              <ChevronLeftIcon />
              <Text fontSize="1rem" color="#696969" fontWeight="bold">
                Voltar
              </Text>
            </HStack>
          </Link>
          <Flex justifyContent="space-between" alignItems="center">
            <Text color="#00335E" fontWeight="bold" fontSize="1.2rem">
              Resgates (Consulta)
            </Text>
            <Menu>
              <MenuButton
                bg="none"
                variant="outline"
                border="1px"
                borderColor="#1B365D"
                color="#1B365D"
                fontSize="0.8rem"
                as={Button}
                rightIcon={<ChevronDownIcon />}
              >
                Exportar Dados
              </MenuButton>
              <MenuList>
                <MenuItem onClick={() => exportData('csv')}>
                  Baixar .csv
                </MenuItem>
                <MenuItem onClick={() => exportData('xls')}>
                  Baixar .xls
                </MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        </Stack>

        <HStack
          bg="#fff"
          wrap="wrap"
          borderRadius="1rem"
          minH="4.3rem"
          spacing={39}
          justify={isWideVersion ? 'flex-start' : 'center'}
          flexDir={{ base: 'column', lg: 'row' }}
          pointerEvents={!loading ? 'all' : 'none'}
          opacity={!loading ? '1' : '0.4'}
        >
          <HStack
            flexDir={{ base: 'column', md: 'column', lg: 'row' }}
            m=".6rem !important"
          >
            <Text fontSize=".8rem" fontWeight="bold" color="#1B365D">
              Filtrar:
            </Text>
            <Input
              color="#1B365D"
              fontSize=".7rem"
              w="9.3rem"
              h="2.1rem"
              placeholder="Nome"
              value={nameFilter}
              onChange={(e) => {
                setNameFilter(e.target.value);
              }}
            />

            <Input
              as={MaskedInput}
              mask={cpf}
              guide={false}
              color="#1B365D"
              fontSize=".7rem"
              w="9.3rem"
              h="2.1rem"
              placeholder="CPF"
              value={cpfFilter}
              onChange={(e) => {
                setCpfFilter(e.target.value);
              }}
            />

            <FormLabel fontSize=".7rem">Data Inicial</FormLabel>
            <Input
              color="#1B365D"
              onChange={(e) => {
                setInitialDate(e.target.value);
              }}
              value={initialDate}
              fontSize=".7rem"
              type="date"
              w="8.1rem"
              h="2.1rem"
              placeholder="Data Inicial"
            />
            <FormLabel fontSize=".7rem">Data Final</FormLabel>
            <Input
              color="#1B365D"
              onChange={(e) => {
                setFinalDate(e.target.value);
              }}
              fontSize=".7rem"
              value={finalDate}
              type="date"
              w="8.1rem"
              h="2.1rem"
              placeholder="Data Final"
            />
          </HStack>
          <Button
            bg="#FA6B25"
            color="#fff"
            fontSize=".7rem"
            w="5.5rem"
            h="2.1rem"
            isLoading={loading}
            onClick={handleFilter}
            m="0 !important"
            _hover={{
              opacity: '.9'
            }}
          >
            Filtrar
          </Button>
          <Button
            bg="#ACACAC"
            color="#fff"
            fontSize=".7rem"
            w="5.5rem"
            h="2.1rem"
            onClick={async () => {
              handleClearFilters();
            }}
            m=".3rem !important"
            _hover={{
              opacity: '.9'
            }}
          >
            Limpar Filtros
          </Button>
        </HStack>
      </Stack>
      {loading ? (
        <Flex w="100%" justify="center">
          <Spinner />
        </Flex>
      ) : (
        <Fade in={!loading}>
          <Stack
            bg="#fff"
            color="#00335E"
            borderRadius="1rem"
            p="1.4rem 1.1rem .8rem"
          >
            <Flex wrap="wrap" gap="5">
              <ValueCard
                value={count}
                description="Quantidade de solicitações"
              />

              <ValueCard
                prefix={solicitado === '-' ? '' : 'R$'}
                value={solicitado}
                fontSize="1.5rem"
                description="Valor solicitado"
              />

              <ValueCard
                prefix={liquido === '-' ? '' : 'R$'}
                value={liquido}
                fontSize="1.5rem"
                description="Valor líquido"
              />
            </Flex>

            {loadingTable ? (
              <Flex w="100%" justify="center">
                <Spinner />
              </Flex>
            ) : (
              <InteractiveTable
                sort="NOME_CLIENTE"
                columns={columns}
                data={table}
                itemsCount={itemsCount}
              />
            )}
          </Stack>
          <Flex
            w="100%"
            justify="flex-end"
            fontSize=".9rem"
            align="center"
            mt="2rem"
          >
            <Flex
              w={{ base: '100%', lg: '60%' }}
              justify={{ base: 'center', lg: 'space-between' }}
              flexDir={{ base: 'column', lg: 'row' }}
            >
              {!loadingTable && (
                <>
                  <Flex
                    align="center"
                    cursor="pointer"
                    justify="center"
                    onClick={() => {
                      setItemsCount(
                        itemsToShow + itemsCount > table.length
                          ? table.length
                          : itemsToShow + itemsCount
                      );
                    }}
                  >
                    <HiPlusCircle size={26} color="#00335E" />
                    <Text>
                      Mais itens (exibindo {itemsCount}/{table.length})
                    </Text>
                  </Flex>
                  <Box>
                    <Select
                      border="1px solid #00335E !important"
                      borderRadius="1rem !important"
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                        setItemsToShow(parseInt(e.target.value))
                      }
                    >
                      <option value={5}>exibir mais 5 por vez</option>
                      <option value={10}>exibir mais 10 por vez</option>
                      <option value={20}>exibir mais 20 por vez</option>
                      <option value={40}>exibir mais 40 por vez</option>
                    </Select>
                  </Box>
                </>
              )}
            </Flex>
          </Flex>
        </Fade>
      )}
      <Modal isOpen={isOpenDetails} onClose={onCloseDetails}>
        <ModalOverlay />
        <ModalContent minW="43rem" borderRadius="1rem">
          <ModalHeader color="#1C375C">Fundos</ModalHeader>
          <ModalCloseButton />

          <Divider />
          {loadingDetails ? (
            <Flex w="100%" justify="center" align="center" h="10rem">
              <Spinner />
            </Flex>
          ) : (
            <ModalBody>
              <TableContainer>
                <Table size="sm" variant="striped">
                  <Thead h="3.25rem">
                    <Tr>
                      <Th fontSize=".9rem" color="#1C375C" textTransform="none">
                        Nome:
                      </Th>
                      <Th fontSize=".9rem" color="#1C375C" textTransform="none">
                        Proposta
                      </Th>
                      <Th fontSize=".9rem" color="#1C375C" textTransform="none">
                        Nome fundo
                      </Th>
                    </Tr>
                  </Thead>

                  <Tbody>
                    <Td>{details[0].SEGURADO}</Td>
                    <Td>{details[0].NUMERO_PROPOSTA}</Td>
                    <Td>{details[0].NOME_FUNDO}</Td>
                    {details.slice(1).map((row) => (
                      <Tr key={row.SEGURADO + row.NUMERO_PROPOSTA}>
                        <Td></Td>
                        <Td></Td>
                        <Td>{row.NOME_FUNDO}</Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
            </ModalBody>
          )}
          <Divider mt="1rem" />
          <ModalFooter justifyContent="center"></ModalFooter>
        </ModalContent>
      </Modal>

      <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent textAlign="center">
          <ModalHeader>Atenção!</ModalHeader>
          <ModalBody>
            <Text>Ops, sua sessão expirou.</Text>
            <Text>
              Por favor, faça novamente o login no Portal do Corretor.
            </Text>
          </ModalBody>

          <ModalFooter justifyContent="center">
            <Link href={process.env.REACT_APP_PORTAL_URL}>
              <Button bg="#FA6B25" color="#fff" colorScheme="orange">
                Voltar
              </Button>
            </Link>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Stack>
  );
};
